import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { pageTitle } from "../context/helper";
import { RequestBranchScreen, RequestFirmScreen, RequestSummaryScreen, RequestSuccessScreen } from "../screens/requestformscreen";

const Stack = createNativeStackNavigator();

const RequestFormStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        component={RequestFirmScreen}
        name="RequestFirm"
        options={{ title: pageTitle("Antrag Firmendaten") }}
      />
      <Stack.Screen
        component={RequestBranchScreen}
        name="RequestBranch"
        options={{ title: pageTitle("Antrag Standorte") }}
      />
      <Stack.Screen
        component={RequestSummaryScreen}
        name="RequestSummary"
        options={{ title: pageTitle("Antrag Zusammenfassung") }}
      />
      <Stack.Screen
        component={RequestSuccessScreen}
        name="RequestSuccess"
        options={{ title: pageTitle("Antrag gesendet") }}
      />
    </Stack.Navigator>
  );
};

export default RequestFormStack;
